import { render, staticRenderFns } from "./FormProposalRefuseReason.vue?vue&type=template&id=65427d5f"
import script from "./FormProposalRefuseReason.vue?vue&type=script&lang=js"
export * from "./FormProposalRefuseReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports